
import { Component, Vue } from 'vue-property-decorator';
import NavBar from '@/components/unique/NavBar.vue';

@Component({
  components: { NavBar }
})
export default class App extends Vue {
  protected drawer: boolean | null = null;
}
